import React from "react";
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    NumberInput,
    required,
    FunctionField,
    Labeled,
} from "react-admin";
import { LVCreateToolbar } from "../core/toolbars";

/*
    To configure pagination - we should have a look at this
    https://github.com/marmelab/react-admin/blob/master/docs/List.md#pagination
*/

export const ChartSubchartList = (props) => (
    <List perPage={100} {...props} sort={{ field: "order", order: "ASC" }}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="order" />
            <EditButton />
        </Datagrid>
    </List>
);

const SubchartTitle = ({ record }) => {
    return <span>Subchart {record ? `"${record.name}"` : ""}</span>;
};

/**
 *  Renders a list of series in a subchart directly - since the nested objects are directly avalable
 *
 *  - there are no round trips to the server.
 *
 * @param {*} record
 * @returns
 */
const SimpleSeriesList = (record) => {
    return record.Series?.map((series) => (
        <div key={series.id}>
            <div style={{ display: "inline-block", width: "1.5rem", textAlign: "center" }}>{series.id}</div>-&nbsp;
            {series.name}
        </div>
    ));
};

export const ChartSubchartEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" validate={[required()]} />
            <TextInput disabled source="id" label="Subchart Id" />
            <NumberInput source="height" validate={[required()]} />
            <NumberInput source="padding" validate={[required()]} />
            <NumberInput source="order" validate={[required()]} />
            <Labeled label="Series in this Subchart" style={{ fontSize: "110%" }}>
                <FunctionField source="Series" label="Series" render={(record) => SimpleSeriesList(record)} />
            </Labeled>
        </SimpleForm>
    </Edit>
);

export class ChartSubchartCreate extends React.Component {
    state = {
        errorMessage: null,
    };

    onError(data) {
        this.setState({ errorMessage: data });
    }

    render() {
        return (
            <Create title={"New Subchart"} {...this.props}>
                <SimpleForm toolbar={<LVCreateToolbar />}>
                    <TextInput source="name" validate={[required()]} />

                    <NumberInput source="height" validate={[required()]} />
                    <NumberInput source="padding" validate={[required()]} />
                    <NumberInput source="order" validate={[required()]} />

                    {this.state.errorMessage}
                </SimpleForm>
            </Create>
        );
    }
}
